import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=d982c7b8&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d982c7b8')) {
      api.createRecord('d982c7b8', component.options)
    } else {
      api.reload('d982c7b8', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=d982c7b8&", function () {
      api.rerender('d982c7b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bI27SHJhlNcx/JS/pricelist.vue"
export default component.exports